import { type MCPServerInfo } from '../../types';

const AshbyServer: MCPServerInfo = {
  serverId: 'ASHBY',
  name: 'Ashby',
  slug: 'ashby',
  description:
    'Official Ashby MCP server. Query your recruiting pipeline, prepare for interviews, and take actions in Ashby — all via OAuth, no API key required.',
  source: {
    sourceType: 'REMOTE_URL',
    mcpServerUrl: 'https://mcp.ashbyhq.com/mcp/v1',
    transport: 'STREAMABLE_HTTP'
  },
  authenticationType: 'OAUTH',
  serverConfig: {
    required: [],
    properties: {}
  },
  installConfig: {
    required: [],
    properties: {}
  }
};

export default AshbyServer;
